import { lift } from './observer';
export class SafeSubscriber {
  constructor(observer, subscription) {
    this.closed = false;
    this.subscription = subscription;
    this.observer = lift(observer);
  }
  next(value) {
    if (!this.closed) {
      try {
        var _this$observer$next, _this$observer;
        (_this$observer$next = (_this$observer = this.observer).next) === null || _this$observer$next === void 0 || _this$observer$next.call(_this$observer, value);
      } catch (e) {
        this.error(e);
      }
    }
  }
  complete() {
    if (!this.closed) {
      var _this$observer$comple, _this$observer2;
      this.closed = true;
      (_this$observer$comple = (_this$observer2 = this.observer).complete) === null || _this$observer$comple === void 0 || _this$observer$comple.call(_this$observer2);
      this.subscription.unsubscribe();
    }
  }
  error(err) {
    if (!this.closed) {
      var _this$observer$error, _this$observer3;
      this.closed = true;
      (_this$observer$error = (_this$observer3 = this.observer).error) === null || _this$observer$error === void 0 || _this$observer$error.call(_this$observer3, err);
      this.subscription.unsubscribe();
    }
  }
}